var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateSolicitacaoDeSenha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3809 0H5.29443C2.39268 0 0 2.39267 0 5.29443V42.6354C0 45.5372 2.39268 47.9299 5.29443 47.9299H42.3809C45.2826 47.9299 47.4208 45.5372 47.6753 42.89V5.29443C47.6753 2.39267 45.2826 0 42.3809 0ZM37.0865 37.5955H10.3343V10.3343H37.0865V37.5955Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.642 15.6288H119.15C122.052 15.6288 124.444 13.2361 124.444 10.3343C124.444 7.43259 122.052 5.03992 119.15 5.03992H69.642C66.7403 5.03992 64.3476 7.43259 64.3476 10.3343C64.3476 13.2361 66.7403 15.6288 69.642 15.6288Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.175 32.0464H69.642C66.7403 32.0464 64.3476 34.4391 64.3476 37.3409C64.3476 40.2426 66.7403 42.6353 69.642 42.6353H119.15C122.052 42.6353 124.444 40.2426 124.444 37.3409C124.47 34.4391 122.077 32.0464 119.175 32.0464Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3809 76.5402H5.29443C2.39268 76.5402 0 78.9329 0 81.8346V119.176C0 122.077 2.39268 124.47 5.29443 124.47H42.3809C45.2826 124.47 47.4208 122.077 47.6753 119.43V81.8346C47.6753 78.9074 45.2826 76.5402 42.3809 76.5402ZM37.0865 114.136H10.3343V86.8745H37.0865V114.136Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.175 81.5544H69.642C66.7403 81.5544 64.3476 83.9471 64.3476 86.8489C64.3476 89.7506 66.7403 92.1433 69.642 92.1433H119.15C122.052 92.1433 124.444 89.7506 124.444 86.8489C124.47 83.9471 122.077 81.5544 119.175 81.5544Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.175 108.587H69.642C66.7403 108.587 64.3476 110.979 64.3476 113.881C64.3476 116.783 66.7403 119.176 69.642 119.176H119.15C122.052 119.176 124.444 116.783 124.444 113.881C124.47 110.954 122.077 108.587 119.175 108.587Z",
    fill: "#D5DCEA",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateSolicitacaoDeSenha);
export default __webpack_public_path__ + "static/media/empty-state-solicitacao-de-senha.a52ba3a1459420662bdc16a86c1592be.svg";
export { ForwardRef as ReactComponent };